import { TbTruck } from 'react-icons/tb'

import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { CRM_LIST_COLUMNS, crmListFields } from '../Contracts/CrmListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Типи авто» (сім'я `CrmList`, `SPEC-007` §4).
 *
 * Транспорт перевізника й іншого перевізника.
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListCarTypeResource: IResourceConfig = {
    title: 'Типи авто',
    fields: crmListFields(),
    table: {
        showColumns: CRM_LIST_COLUMNS,
    },
    filter: {
        includeFields: ['id', 'title'],
    },
    places: {
        top: <TopMenu current="car-types" />,
    },
    restUrl: '/services/car_types',
    pageUrl: '/settings/car-types',
    pageConfig: {
        title: 'Типи авто',
        icon: <TbTruck />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
